import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/lib/integration/react';

import registerServiceWorker from "./registerServiceWorker";
// import configureStore from "./redux/store/";
import { persistor, store } from './redux/store/';
import App from "./containers/app/App";

// style
import "bootstrap/dist/css/bootstrap.css";
import "./assets/fonts/font-awesome/css/font-awesome.min.css";
// import "./assets/stack/css/app.css";
// import './assets/vendors/mdb/css/mdb.css';
// import './assets/vendors/bootstrap-rtl.min.css';
// import './assets/fonts/vazir/vazir.css';
// import './assets/fonts/roboto/roboto.css';
import './assets/fonts/flaticon/Flaticon.css';
import './assets/fonts/line-awesome/line-awesome.css';
import 'react-toastify/dist/ReactToastify.min.css';
import './assets/custom/style.bundle.css';
import PageLoader from "./components/loader/PageLoader";

// if need jquery
// import jquery from "jquery";
// window.$ = window.jQuery = jquery;
// window.Popper = require("popper.js");
// require("bootstrap/dist/js/bootstrap");



// const store = configureStore();
// CheckUserLoginFromApi(store);

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={<PageLoader type="bubbles" color="#0ebcf2" />} persistor={persistor}>
            <App store={store}/>
        </PersistGate>
    </Provider>,
    document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js